import { render } from "./ArrowRightPopUpSvg.vue?vue&type=template&id=35d42778"
import script from "./ArrowRightPopUpSvg.vue?vue&type=script&lang=js"
export * from "./ArrowRightPopUpSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__